(function() {
  "use strict";

  angular
    .module("travelExpenses")
    .controller("TravelExpensesFormController", TravelExpensesFormController);
  TravelExpensesFormController.$inject = [
    "$state",
    "$scope",
    "$timeout",
    "$stateParams",
    "$uibModal",
    "mode",
    "FileUploader",
    "API_BASE",
    "ExpoService",
    "VirtualFairService",
    "CitiesByExpoService",
    "CurrencyService",
    "TravelExpenseService",
    "toastr",
    "InvoicesService",
    "EventsService",
    "AccountService",
    "SellerService",
    "expenseTypeList",
    "paymentTypeList",
    "sellerList"
  ];

  function TravelExpensesFormController(
    $state,
    $scope,
    $timeout,
    $stateParams,
    $uibModal,
    mode,
    FileUploader,
    API_BASE,
    ExpoService,
    VirtualFairService,
    CitiesByExpoService,
    CurrencyService,
    TravelExpenseService,
    toastr,
    InvoicesService,
    EventsService,
    AccountService,
    SellerService,
    expenseTypeList,
    paymentTypeList,
    sellerList
  ) {
    var vm = this;

    // console.log(physicalFairsList);

    vm.filters = TravelExpenseService.getFilters();

    // new controls funcions
    vm.preLoad = preLoad;

    vm.datePicker = {
      autoApply: true
    };
    vm.sellers = [];
    vm.mode = mode;
    vm.picture = "";
    vm.othersEventsList = [];
    vm.physicalFairList = [];
    vm.virtualFairList = [];
    vm.othersEventsSelected = "";
    vm.expenseTypeSelected = "";
    vm.expenseTypeList = expenseTypeList;
    vm.paymentTypeSelected = "";
    vm.paymentTypeList = paymentTypeList;
    vm.toggleValue = false;
    vm.categorySelected = "";
    vm.categoryList = [];
    vm.citySelected = "";
    vm.expenseDate = new Date();
    vm.mediaTypeImage = false;
    vm.hasFileToUpload = false;
    vm.dateOptions = {
      autoUpdateInput: true,
      autoApply: true,
      singleDatePicker: true,
      locale: {
        format: "DD/MMM/YYYY",
        cancelLabel: "Close"
      }
    };
    vm.atmItems = [
      {
        expenseDate: moment(),
        expenseTypeSelected: "",
        categorySelected: "",
        selectedCurrency: "",
        amount: "",
        othersEventsSelected: "",
        expoSelected: "",
        citySelected: "",
        description: "",
        picture: "",
        file_path: "",
        full_file_path: "",
        exchangeRateUsd: "",
        amountUsd: "",
        equivalentTo: ""
      }
    ];
    vm.expoSelected = "";
    vm.cities = [];
    vm.expo = [];
    vm.description = "";
    vm.cameraStatus = false;
    vm.showImage = false;
    vm.mediaImage = [];
    vm.filePath = false;
    vm.currencies = [];
    vm.selectedCurrency = "";
    vm.amount = [];
    vm.amountUsd = [];
    vm.amountShared = 0;
    vm.amountInPocket = 0;
    vm.exchangeRateUsd = [];
    vm.mediaTypes = [
      {
        value: "image",
        name: "Image"
      },
      {
        value: "video",
        name: "Video"
      }
    ];
    vm.confirmedPhysicalFair = [
      {
        name: " "
      },
      {
        name: "Both"
      },
      {
        name: "Yes"
      },
      {
        name: "No"
      }
    ];
    vm.shareStaffList = "";
    vm.shareStaffSelected = "";
    vm.staff = [];
    vm.totalShare = "";
    vm.hasSharingApproved = false;
    vm.showPicture = true;

    vm.toggleFunction = toggleFunction;
    vm.loadSellers = loadSellers;
    vm.selectExpo = selectExpo;
    vm.getOthersEvents = getOthersEvents;
    vm.getAccountsTravelExpense = getAccountsTravelExpense;
    vm.beforeSave = beforeSave;
    vm.selectCitiesByExpo = selectCitiesByExpo;
    vm.fillForm = fillForm;
    vm.updateExpense = updateExpense;
    vm.createExpense = createExpense;
    vm.turnOnCamera = turnOnCamera;
    vm.turnOnCameraAtm = turnOnCameraAtm;
    vm.showUpload = showUpload;
    vm.getCurrencies = getCurrencies;
    vm.queryPrepare = queryPrepare;
    vm.convertToUTC = convertToUTC;
    vm.cleanFields = cleanFields;
    vm.validSalaryAdvance = validSalaryAdvance;
    vm.convertCurrencyToUsd = convertCurrencyToUsd;
    vm.atmConvertToUsd = atmConvertToUsd;
    vm.getExchangeRate = getExchangeRate;
    vm.getAtmExchangeRate = getAtmExchangeRate;
    vm.addAtmItem = addAtmItem;
    vm.removeItem = removeItem;
    vm.changePaymentType = changePaymentType;
    vm.changeExpenseType = changeExpenseType;
    vm.shareStaff = shareStaff;
    vm.removeSharingWithStaff = removeSharingWithStaff;
    vm.showUploadAtm = showUploadAtm;
    vm.atmFileUploader = atmFileUploader;
    vm.selectCitiesByExpoAtm = selectCitiesByExpoAtm;
    vm.calculateMaxValue = calculateMaxValue;
    vm.getExtension = getExtension;
    vm.base64MimeType = base64MimeType;
    vm.statement = "";
    vm.setStatement = setStatement;
    vm.expenseId = null;
    vm.totalAtm = 0;
    vm.showPockedBalance = true;
    vm.calcBalance = calcBalance;
    vm.setEquivalentTo = setEquivalentTo;
    vm.redirect = redirect;
    vm.selectExpoAtm = selectExpoAtm;
    vm.selectVirtualFairs = selectVirtualFairs;
    vm.selectPhysicalFairs = selectPhysicalFairs;
    vm.selectedExpo = selectedExpo;
    vm.uploadAtmFile = uploadAtmFile;
    vm.loadNvFileSelect = loadNvFileSelect;

    /*PAGINATION*/
    vm.pageChanged = pageChanged;
    vm.setPage = setPage;
    vm.totalItems = [];
    vm.to = [];
    vm.currentPage = null;
    vm.itemsPerPage = [];
    vm.page = 1;

    function activate() {

      vm.shareStaffList = sellerList;
      // console.log("inicia a lista de expos");
      // vm.getLists().then(function(){
      //     console.log(vm.physicalFairList, vm.virtualFairList, vm.othersEventsList);
      // });
      // console.log('Fim');
      // vm.getOthersEvents();
      vm.loadNvFileSelect();
      vm.getCurrencies();
      vm.getAccountsTravelExpense();
      if (!$stateParams.expenseId) {
        vm.loadSellers();
      } else {
        vm.fillForm($stateParams.expenseId);
      }
      vm.setStatement();
      if (
        typeof $stateParams.expenseId != "undefined" &&
        $stateParams.expenseId
      ) {
        vm.expenseId = $stateParams.expenseId;
      }
    }

    function loadNvFileSelect () {

        var token = localStorage.getItem("id_token");
        var tokenHeader = "Bearer " + token;
        vm.uploader = new FileUploader({
          url: API_BASE + "/travel-expenses/uploadImage",
          withCredentials: false,
          method: "POST",
          headers: {
            Authorization: tokenHeader
          },
          queueLimit: 1,
          onBeforeUploadItem: function(item) {
            item.formData.push({ vmFile: vm.picture });
          },
          onCompleteItem: function(item, response, status, headers) {
            if (response.status) {
              vm.filePath = response.url;
              vm.queryPrepare();
              //toastr.success(response.message);
            } else {
              // toastr.error(response.message);
              // var encodedErr = btoa(unescape(encodeURIComponent(JSON.stringify(response || 'empty response'))));
              var encodedErr = btoa(JSON.stringify(response || "empty response"));
              toastr.error(
                "Something is not right. Please check the data entered and try again.<br><br>If you think something is wrong, <a onclick=\"copyText('" +
                  encodedErr +
                  "')\"><b>click here</b></a> to copy the error details and report back to the development team.",
                {
                  allowHtml: true,
                  timeOut: 10000
                }
              );
            }
          },
          onAfterAddingFile: function(item) {
            var reader = new FileReader();
            reader.onload = function(event) {
              $scope.$apply(function() {
                vm.picture = event.target.result;
              });
            };
            reader.readAsDataURL(item._file);
            vm.hasFileToUpload = true;
          },
          onWhenAddingFileFailed: function(item, filter, options) {
            if (filter.name == "queueLimit") {
              vm.uploader.clearQueue();
              vm.uploader.addToQueue(item);
            }
          }
        });
        return vm.uploader;
    }

    function atmFileUploader(atm) {
      var token = localStorage.getItem("id_token");
      var tokenHeader = "Bearer " + token;

      return new FileUploader({
        url: API_BASE + "/travel-expenses/uploadImage",
        withCredentials: false,
        method: "POST",
        headers: {
          Authorization: tokenHeader
        },
        queueLimit: 1,
        onBeforeUploadItem: function(item) {
          item.formData.push({ vmFile: atm.picture });
        },
        onCompleteItem: function(item, response, status, headers) {
          if (response.status) {
            atm.filePath = response.url;
            vm.queryPrepare();
            toastr.success(response.message);
          } else {
            toastr.error(response.message);
          }
        },
        onFileSelected: function (item) {
          $timeout(function(){
            
          }, 1)
        },
        onAfterAddingFile: function(item) {

          console.log(item);
          console.log("File addeded");
          $timeout(function(){
            var reader = new FileReader();
            reader.onload = function(event) {
              $scope.$apply(function() {
                atm.picture = event.target.result;
                atm.full_file_path = event.target.result;
              });
            };
            reader.readAsDataURL(item._file);
            vm.hasFileToUpload = true;
            console.log(atm.picture);
          },2000)
          
        },
        onWhenAddingFileFailed: function(item, filter, options) {
          if (filter.name == "queueLimit") {
            vm.file.clearQueue();
            vm.atmFileUploader.addToQueue(item);
          }
        }
      });
    }

    function loadSellers() {
      //
      if ($stateParams.expenseId) {
        if (typeof vm.form.share != "undefined") {
          vm.staff = angular.forEach(vm.form.share, function(share) {
            share.name = share.staff.name;
            return share;
          });
        }
        vm.shareStaffList.map(function(obj) {
          angular.forEach(vm.form.share, function(share) {
            if (obj.id == share.staff.id) {
              obj.inactive = true;
            }
            if (share.approved_at) {
              vm.hasSharingApproved = true;
            }
          });
        });
      }
    }

    function getCurrencies() {
      InvoicesService.getPaymentCurrencies().then(function(response) {
        vm.currencies = response.data;
      });
    }

    function getAccountsTravelExpense() {
      AccountService.getAccountsTravelExpenses().then(function(response) {
        vm.categoryList = response.data;
      });
    }

    async function selectExpo() {
      if (
        typeof vm.expenseTypeSelected.id != "undefined" &&
        vm.expenseTypeSelected.id == "virtual_event"
      ) {
        // vm.expos = [];
        // angular.copy(vm.virtualFairList, vm.expos);
        if ($stateParams.expenseId && vm.form.virtual_fair_id != null) {
          vm.expoSelected = vm.virtualFairList.filter(function(obj) {
            return obj.id == vm.form.virtual_fair_id;
          })[0];
        }
      }
      if (
        typeof vm.expenseTypeSelected.id != "undefined" &&
        vm.expenseTypeSelected.id == "physical_event"
      ) {
        //vm.expos = [];
        //angular.copy(vm.physicalFairList, vm.expos);
        if (
          $stateParams.expenseId &&
          vm.form.expo != null &&
          vm.form.expo.expo_id
        ) {
          await vm.selectedExpo();
          vm.selectCitiesByExpo(vm);
        }
      }
      if (
        typeof vm.expenseTypeSelected.id != "undefined" &&
        vm.expenseTypeSelected.id == "other_event"
      ) {
        if ($stateParams.expenseId && vm.form.other_event_id) {
          vm.othersEventsSelected = vm.othersEventsList.filter(function(obj) {
            return obj.id == vm.form.other_event_id;
          })[0];
        }
        return vm.othersEventsList;
      }
    }

    function selectedExpo() {
      vm.expoSelected = vm.physicalFairList.filter(function(obj) {
        return obj.id == vm.form.expo.expo_id;
      })[0];
    }

    function selectExpoAtm(obj) {
      try {
        if (obj.expenseTypeSelected.id == "virtual_event") {
          // if(vm.exposVirtualFair.length == 0) {
          //     VirtualFairService.getAll().then(function (response) {
          //         vm.exposVirtualFair = response.data;
          //         return vm.exposVirtualFair;
          //     })
          // } else {
          //     obj.expos = [];
          //     obj.expos = vm.exposVirtualFair;
          //     return vm.exposVirtualFair;
          // }
          //   obj.expos = [];
          //   angular.copy(vm.virtualFairList, obj.expos);
        }
        // if(obj.expenseTypeSelected.id == 'other_event') {
        //     if(vm.othersEventsList.length == 0) {
        //         EventsService.getOthersEvents().then(function (response) {
        //             vm.othersEventsList = response.data;
        //             return vm.othersEventsList;
        //         });
        //     } else {
        //         return vm.othersEventsList;
        //     }
        // }
        if (obj.expenseTypeSelected.id == "physical_event") {
          // if(vm.exposPhysicalFair.length == 0) {
          //     ExpoService.getExpos().then(function (response) {
          //         vm.exposPhysicalFair = response.data;
          //         return vm.exposPhysicalFair;
          //     });
          // } else {
          //     obj.expo = [];
          //     obj.expo = vm.exposVirtualFair;
          //     return vm.exposVirtualFair;
          // }
          //   obj.expos = [];
          //   angular.copy(vm.physicalFairList, obj.expos);
        }
      } catch (e) {}
    }

    function selectCitiesByExpo(obj) {
      let id = 0;
      if (typeof obj.expoSelected.id === "undefined") {
        console.warn("Obj undefined expo selected");
        return false;
      }
      id = obj.expoSelected.id;
      CitiesByExpoService.getCities(id)
        .then(function(response) {
          obj.cities = response.data;
          obj.cities.unshift({
            id: 0,
            city_id: 0,
            alias: "",
            city_image_url: "",
            city_name: "-- ALL --",
            country_id: "",
            country_name: "",
            is_school_visit: 0,
            expos_locations_id: 0
          });
          vm.citySelected = obj.cities[0];
          if ($stateParams.expenseId) {
            if (
              obj.form.expo !== null &&
              obj.form.expo.location != null &&
              typeof obj.form.expo.location.address.city !== "undefined"
            ) {
              obj.citySelected = obj.cities.filter(function(item) {
                return item.expos_locations_id == obj.form.expo.location_id;
              })[0];
            }
          }
        })
        .catch(function(err) {});
    }

    function selectCitiesByExpoAtm(obj) {
      let id = 0;
      obj.citySelected = {};
      if (typeof obj.expoSelected.id === "undefined") {
        console.warn("Obj undefined expo selected");
        return false;
      }
      id = obj.expoSelected.id;
      CitiesByExpoService.getCities(id)
        .then(function(response) {
          obj.cities = response.data;
          obj.cities.unshift({
            id: 0,
            city_id: 0,
            alias: "",
            city_image_url: "",
            city_name: "-- ALL --",
            country_id: "",
            country_name: "",
            is_school_visit: 0,
            expos_locations_id: 0
          });
          obj.citySelected = obj.cities[0];
          if ($stateParams.expenseId) {
            if (
              typeof obj.expo_location !== "undefined" &&
              obj.expo_location != null &&
              typeof obj.expo_location.address !== "undefined"
            ) {
              obj.citySelected = obj.cities.filter(function(item) {
                return item.id == obj.expo_location.address.city.id;
              })[0];
            }
          }
        })
        .catch(function(err) {});
    }

    function fillForm(expenseId) {
      try {
        let query = {};
        query["id"] = expenseId;
        TravelExpenseService.editExpense(query)
          .then(function(response) {
            vm.form = response.data;
            $timeout(function() {
              vm.expenseDate = vm.form.date;
              vm.paymentTypeSelected = vm.paymentTypeList.filter(function(obj) {
                return obj.name == vm.form.payment_type_name;
              })[0];

              vm.categorySelected = vm.categoryList.filter(function(obj) {
                return obj.id == vm.form.category_id;
              })[0];

              if (vm.form.share.length > 0) {
                vm.loadSellers();
                vm.toggleValue = true;
              }

              vm.picture = vm.form.file_path ? vm.form.full_file_path : "";
              vm.selectedCurrency = vm.currencies.filter(function(obj) {
                return obj.code == vm.form.currency.code;
              })[0];
              vm.amount = vm.form.amount;
              vm.convertCurrencyToUsd();
              // debugger;
              vm.amountUsd = vm.form.amount_usd;
              vm.amountShared = vm.form.amount_shared;
              vm.amountInPocket = vm.amount - vm.amountShared;
              vm.exchangeRateUsd = vm.form.exchange_rate_usd;
              vm.description = vm.form.description;

              // Condição primária, se diferente de ATM então o form principal segue com os selects
              if (vm.paymentTypeSelected.id != "atm") {
                vm.expenseTypeSelected = vm.expenseTypeList.filter(function(
                  obj
                ) {
                  return obj.id == vm.form.type;
                })[0];

                // Re-check se as expos foram carregadas
                if (
                  vm.expenseTypeSelected.id == "virtual_event" ||
                  vm.expenseTypeSelected.id == "physical_event"
                ) {
                  vm.selectExpo();
                }
              }

              // ATM
              if (vm.form.atm.length > 0) {
                vm.atmItems = angular.forEach(vm.form.atm, function(value) {
                  if (value.type == "physical_event" && value.expo_id) {
                    $timeout(function() {
                      //value.expos = [];
                      //angular.copy(vm.physicalFairList, value.expos);
                      value.expoSelected = {};
                      value.expoSelected = vm.physicalFairList.filter(function(
                        el
                      ) {
                        return el.id == value.expo_id;
                      })[0];
                    }, 1).then(function() {
                      vm.selectCitiesByExpoAtm(value);
                    });
                  }
                  if (value.type == "virtual_event" && value.expo_id) {
                    $timeout(function() {
                      //value.expos = [];
                      //angular.copy(vm.virtualFairList, value.expos);
                      value.expoSelected = {};
                      value.expoSelected = value.expos.filter(function(el) {
                        return el.id == value.expo_id;
                      })[0];
                    });
                  }
                  if (value.type == "other_event" && value.other_event_id) {
                    // vm.selectExpoAtm(value);
                    $timeout(function() {
                      value.othersEventsSelected = {};
                      value.othersEventsSelected = vm.othersEventsList.filter(
                        function(el) {
                          return el.id == value.other_event_id;
                        }
                      )[0];
                    }, 1);
                  }

                  // value = JSON.parse(value); // Comentado, estava gerando erros
                  value.id = value.id;
                  value.expenseDate = value.date;
                  value.expenseTypeSelected = vm.expenseTypeList.filter(
                    function(el) {
                      return el.id == value.type;
                    }
                  )[0];
                  value.categorySelected = value.category;
                  value.selectedCurrency = value.currency;
                  value.picture = "";
                  value.equivalentTo = value.equivalent_to;
                  //EXPO ATM
                  //value.expo = vm.selectExpoAtm(value);
                  return value;
                });

                // Calc balance
                vm.calcBalance();
              }
            }, 1);
          })
          .catch(function(err) {});
      } catch (error) {}
    }

    function beforeSave() {
      if (
        typeof vm.paymentTypeSelected.id !== "undefined" &&
        vm.paymentTypeSelected.id === "atm"
      ) {
        // vm.atmConvertToUsd();
        vm.queryPrepare();
      } else {
        if (vm.hasFileToUpload) {
          vm.uploader.uploadAll();
        } else {
          vm.queryPrepare();
        }
      }
    }

    function convertToUTC(date) {
      return new Date(
        Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds()
        )
      );
    }

    function queryPrepare() {
      let query = {};
      if (typeof vm.expenseDate !== "undefined") {
        query["date"] = vm.expenseDate;
      }
      if (typeof vm.expoSelected !== "undefined" && vm.expoSelected !== "") {
        query["expo_id"] = vm.expoSelected.id;
        if (typeof vm.citySelected !== "undefined" && vm.citySelected !== "") {
          query["location_id"] = null;
          if (vm.citySelected !== -1) {
            query["location_id"] = vm.citySelected.expos_locations_id;
          }
        }
      }
      if (typeof vm.expenseTypeSelected !== "undefined") {
        query["type"] = vm.expenseTypeSelected.id;
      }
      if (typeof vm.paymentTypeSelected !== "undefined") {
        query["payment_type"] = vm.paymentTypeSelected.id;
      }
      if (
        vm.paymentTypeSelected.id !== "atm" &&
        typeof vm.categorySelected.id !== "undefined"
      ) {
        query["category_id"] = vm.categorySelected.id;
      }
      if (typeof vm.filePath !== "undefined" && vm.filePath !== false) {
        query["file_path"] = vm.filePath;
      }
      if (
        typeof vm.selectedCurrency !== "undefined" &&
        vm.selectedCurrency !== ""
      ) {
        query["currency"] = vm.selectedCurrency.code;
      }
      if (typeof vm.amount !== "undefined" && vm.amount !== "") {
        query["amount"] = vm.amount;
      }
      if (typeof vm.amountUsd !== "undefined" && vm.amountUsd !== "") {
        query["amount_usd"] = vm.amountUsd;
      }
      if (
        typeof vm.exchangeRateUsd !== "undefined" &&
        vm.exchangeRateUsd !== ""
      ) {
        query["exchange_rate_usd"] = vm.exchangeRateUsd;
      }
      if (typeof vm.othersEventsSelected !== "undefined") {
        query["other_event_id"] = vm.othersEventsSelected.id;
      }
      if (typeof vm.description !== "undefined") {
        query["description"] = vm.description;
        // if(typeof vm.statement.description !== 'undefined') {
        //     query['description'] = vm.statement.description + ': ' + vm.description;
        // }
      }
      if (
        typeof vm.paymentTypeSelected.id !== "undefined" &&
        vm.paymentTypeSelected.id === "atm"
      ) {
        query["atm_items"] = vm.atmItems;
      }
      if (vm.staff.length > 0) {
        query["staff"] = vm.staff;
      }
      if (typeof vm.statement.id !== "undefined") {
        query["statement_id"] = vm.statement.id;
      }
      if ($stateParams.expenseId) {
        query["id"] = $stateParams.expenseId;
        vm.updateExpense(query);
      } else {
        vm.createExpense(query);
      }
    }

    function createExpense(query) {
      TravelExpenseService.save(query)
        .then(function(response) {
          if (response.data) {
            toastr.success("Successfully saved!");
            if (typeof vm.statementId != "undefined" && vm.statementId) {
              TravelExpenseService.setFilters(vm.filters);
              $state.go("root.travel_expenses.statement.list");
            } else {
              TravelExpenseService.setFilters(vm.filters);
              $state.go("root.travel_expenses.list");
            }
          }
        })
        .catch(function(err) {
          var encodedErr = btoa(JSON.stringify(err.data || "empty response"));
          toastr.error(
            "Something is not right. Please check the data entered and try again.<br><br>If you think something is wrong, <a onclick=\"copyText('" +
              encodedErr +
              "')\"><b>click here</b></a> to copy the error details and report back to the development team.",
            {
              allowHtml: true,
              timeOut: 10000
            }
          );
        });
    }

    function updateExpense(query) {
      TravelExpenseService.update(query)
        .then(function(response) {
          if (response.data) {
            toastr.success("Successfully updated!");
            if (
              typeof $stateParams.origin !== "undefined" &&
              $stateParams.origin == "approval"
            ) {
              TravelExpenseService.setFilters(vm.filters);
              $state.go("root.travel_expenses.report");
            } else if (typeof vm.statementId != "undefined" && vm.statementId) {
              TravelExpenseService.setFilters(vm.filters);
              $state.go("root.travel_expenses.statement.list");
            } else {
              TravelExpenseService.setFilters(vm.filters);
              $state.go("root.travel_expenses.list");
            }
          }
        })
        .catch(function(err) {
          var encodedErr = btoa(JSON.stringify(err.data || "empty response"));
          toastr.error(
            "Something is not right. Please check the data entered and try again.<br><br>If you think something is wrong, <a onclick=\"copyText('" +
              encodedErr +
              "')\"><b>click here</b></a> to copy the error details and report back to the development team.",
            {
              allowHtml: true,
              timeOut: 10000
            }
          );
        });
    }

    function setPage(pageNo) {
      vm.currentPage = pageNo;
    }

    function pageChanged(pageNo) {
      vm.page = vm.currentPage;
      vm.getByFilter();
    }

    function turnOnCamera() {
      vm.cameraStatus = true;
      vm.showImage = false;
      $uibModal.open({
        size: "lg",
        templateUrl: "templates/travelexpenses/form/take-photo.html",
        controller: [
          "$uibModalInstance",
          function($uibModalInstance) {
            var modal = this;
            modal.cancel = $uibModalInstance.close;
            modal.save = save;
            modal.turnOff = turnOff;

            function save() {
              $timeout(function() {
                angular.element("#ng-camera-action").trigger("click");
                vm.picture = modal.picture;
                urltoFile(modal.picture, "receipt.jpg")
                  .then(function(file) {
                    vm.uploader.addToQueue(file);
                  })
                  .then(modal.cancel);
              });
            }

            function urltoFile(url, filename, mimeType) {
              mimeType = mimeType || (url.match(/^data:([^;]+);/) || "")[1];
              return fetch(url)
                .then(function(res) {
                  return res.arrayBuffer();
                })
                .then(function(buf) {
                  return new File([buf], filename, {
                    type: mimeType
                  });
                });
            }

            function turnOff() {
              $scope.$broadcast("ngWebcam_on");
            }
          }
        ],
        controllerAs: "modal"
      });
    }

    function turnOnCameraAtm(atm) {
      atm.cameraStatus = true;
      atm.showImage = false;
      $uibModal.open({
        size: "lg",
        templateUrl: "templates/travelexpenses/form/take-photo.html",
        controller: [
          "$uibModalInstance",
          function($uibModalInstance) {
            var modal = this;
            modal.cancel = $uibModalInstance.close;
            modal.save = save;
            modal.turnOff = turnOff;

            function save() {
              $timeout(function() {
                angular.element("#ng-camera-action").trigger("click");
                atm.picture = modal.picture;
                atm.full_file_path = modal.picture;
                urltoFile(modal.picture, "receipt.jpg")
                  .then(function(file) {
                    vm.atmFileUploader(atm).addToQueue(file);
                  })
                  .then(modal.cancel);
              });
            }
            function urltoFile(url, filename, mimeType) {
              mimeType = mimeType || (url.match(/^data:([^;]+);/) || "")[1];
              return fetch(url)
                .then(function(res) {
                  return res.arrayBuffer();
                })
                .then(function(buf) {
                  return new File([buf], filename, {
                    type: mimeType
                  });
                });
            }
            function turnOff() {
              $scope.$broadcast("ngWebcam_on");
            }
          }
        ],
        controllerAs: "modal"
      });
    }

    function cleanFields(atm) {
      vm.expoSelected = "";
      vm.citySelected = "";
      vm.othersEventsSelected = "";
      vm.validSalaryAdvance(atm);
      vm.selectExpo();
    }

    function showUpload() {
      vm.cameraStatus = false;
      vm.showImage = true;
      vm.picture = "";
      angular.element("#image").trigger("click");
    }

    function showUploadAtm(atm, index) {
      atm.cameraStatus = false;
      atm.showImage = true;
      atm.picture = "";
      angular.element("#image-" + index).trigger("click");
    }

    function validSalaryAdvance(obj) {
      vm.changePaymentType(obj);
      vm.changeExpenseType(obj);
      if (
        obj.expenseTypeSelected &&
        obj.expenseTypeSelected.id === "salary_advance" &&
        (obj.paymentTypeSelected.id === "personal_credit_card" ||
          obj.paymentTypeSelected.id === "personal_cash")
      ) {
        obj.expenseTypeSelected = "";
        alertify.alert(
          "Salary advance option",
          "This option can not be selected if you choose Personal Cash or Personal Credit Card."
        );
      }

      if (obj.paymentTypeSelected.id == "atm") {
        vm.showPicture = false;
      } else {
        vm.showPicture = true;
      }
    }

    function getExchangeRate() {
      let query = {};
      query["from"] = vm.selectedCurrency.code;
      query["to"] = "USD";
      query["date"] = moment().format("YYYY-MM-DD");
      return CurrencyService.getExchangeRate(query);
    }

    function getAtmExchangeRate(atm) {
      let query = {};
      query["from"] = atm.selectedCurrency.code;
      query["to"] = "USD";
      query["date"] = moment().format("YYYY-MM-DD");
      return CurrencyService.getExchangeRate(query);
    }

    function convertCurrencyToUsd() {
      vm.amountInPocket = vm.amount;

      if (vm.statement.value == null) {
        let exchangeRatePromise = vm.getExchangeRate();
        exchangeRatePromise
          .then(function(response) {
            vm.exchangeRateUsd = response.data;
            vm.amountUsd = vm.amount * vm.exchangeRateUsd;
            vm.totalShare = vm.amount;
          })
          .catch(function(err) {});
      }
    }

    function addAtmItem() {
      vm.atmItems.push({
        expenseDate: moment(),
        expenseTypeSelected: "",
        categorySelected: "",
        selectedCurrency: "",
        amount: "",
        othersEventsSelected: "",
        expoSelected: "",
        citySelected: "",
        description: "",
        picture: "",
        exchange_rate_usd: "",
        amount_usd: "",
        equivalentTo: ""
      });
    }

    function removeItem(index) {
      if (vm.atmItems.length > 1) {
        vm.atmItems.splice(index, 1);
      }
    }

    function atmConvertToUsd(atm) {
      let exchangeRatePromise = vm.getAtmExchangeRate(atm);
      exchangeRatePromise
        .then(function(response) {
          vm.exchangeRateUsd = response.data;
          atm.exchange_rate_usd = vm.exchangeRateUsd;
          atm.amount_usd = atm.amount * vm.exchangeRateUsd;
        })
        .catch(function(err) {});
    }

    function changePaymentType(obj) {
      if (vm.paymentTypeSelected.id == "atm") {
        obj.othersEventsSelected = "";
        obj.expenseTypeSelected = "";
        obj.citySelected = "";
        obj.expoSelected = "";
        obj.categorySelected = "";
        vm.atmItems = [];
        vm.addAtmItem();
      }
    }

    function changeExpenseType(obj) {
      if (!obj.expenseTypeSelected) {
        return;
      }
      if (obj.expenseTypeSelected.id == "other_event") {
        obj.citySelected = "";
        obj.expoSelected = "";
      }
      if (
        obj.expenseTypeSelected.id == "physical_event" ||
        obj.expenseTypeSelected.id == "virtual_event"
      ) {
        obj.othersEventsSelected = "";
        if (obj.expenseTypeSelected.id == "physical_event") {
          obj.expos = [];
          // angular.copy(vm.physicalFairList, obj.expos);
        }
        if (obj.expenseTypeSelected.id == "virtual_event") {
          obj.citySelected = "";
          obj.expos = [];
          // angular.copy(vm.virtualFairList, obj.expos);
        }
      }
      if (
        obj.expenseTypeSelected.id !== "physical_event" &&
        obj.expenseTypeSelected.id !== "other_event"
      ) {
        obj.othersEventsSelected = "";
        obj.citySelected = "";
        obj.expoSelected = "";
      }
      if (vm.paymentTypeSelected.id == "atm") {
        obj.categorySelected = "";
      }
      if (obj.expenseTypeSelected.id == "salary_advance") {
        obj.categorySelected = vm.categoryList.filter(function(item) {
          return item.id === 5;
        })[0];
      }
      //vm.selectExpoAtm(obj);
    }

    function shareStaff() {
      vm.shareStaffSelected.inactive = true;
      vm.staff.push(vm.shareStaffSelected);
      vm.shareStaffSelected = "";
    }

    function removeSharingWithStaff(current_staff) {
      current_staff.inactive = false;
      vm.staff.splice(vm.staff.indexOf(current_staff), 1);
    }

    function toggleFunction() {
      if (!vm.hasSharingApproved) {
        vm.shareStaffSelected = [];
        vm.shareStaffList.map(function(el) {
          el.inactive = false;
        });
        vm.staff = [];
      }
    }

    function calculateMaxValue(share) {
      let total = 0;
      total = angular.forEach(vm.staff, function(item) {
        total += item.amount;
        if (total > vm.amount) {
          alertify.alert(
            "Alert",
            "The shared value cannot be greater than the value of ATM"
          );
          share.amount = 0;
          return share.amount;
        }
      });
    }

    function getExtension(file) {
      if (file) {
        let ext = file.split(".").pop();
        if (ext == "jpg" || ext == "jpeg" || ext == "gif" || ext == "png") {
          return true;
        }
        ext = vm.base64MimeType(file);
        if (
          ext == "image/jpg" ||
          ext == "image/jpeg" ||
          ext == "image/gif" ||
          ext == "image/png"
        ) {
          return true;
        }
      }
      return false;
    }

    function base64MimeType(encoded) {
      var result = null;
      if (typeof encoded !== "string") {
        return result;
      }
      var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
      if (mime && mime.length) {
        result = mime[1];
      }
      return result;
    }

    function setStatement() {
      if (
        typeof $stateParams.statementId !== "undefined" &&
        $stateParams.statementId
      ) {
        vm.statementId = $stateParams.statementId;
        TravelExpenseService.getStatement(vm.statementId).then(function(
          response
        ) {
          vm.statement = response.data;
          if (vm.statement.value !== null) {
            vm.amountUsd = response.data.value;
          }
          vm.expenseDate = moment(vm.statement.date);
          // vm.description = vm.statement.description;
          vm.paymentTypeList = [
            { name: "Business Credit Card", id: "business_credit_card" },
            { name: "ATM Business Card", id: "atm" }
          ];
        });
      }
    }

    window.copyText =
      window.copyText ||
      function(text) {
        var tmp = $("<input>");
        $("body").append(tmp);
        tmp.val(text).select();
        document.execCommand("copy");
        tmp.remove();
      };

    function setEquivalentTo(atm) {
      if (atm.selectedCurrency == vm.selectedCurrency) {
        atm.equivalentTo = atm.amount;
        vm.calcBalance();
      }
    }

    function calcBalance() {
      let amountInPocket = vm.amount - vm.amountShared;

      angular.forEach(vm.atmItems, function(value) {
        if (value.equivalentTo) {
          amountInPocket -= value.equivalentTo;
        } else {
          vm.showPockedBalance = false;
        }
      });

      vm.amountInPocket = amountInPocket;
    }

    function redirect() {
      if (
        typeof $stateParams.origin !== "undefined" &&
        $stateParams.origin == "approval"
      ) {
        TravelExpenseService.setFilters(vm.filters);
        $state.go("root.travel_expenses.report");
      } else if (typeof vm.statementId != "undefined" && vm.statementId != "") {
        TravelExpenseService.setFilters(vm.filters);
        $state.go("root.travel_expenses.statement.list");
      } else {
        TravelExpenseService.setFilters(vm.filters);
        $state.go("root.travel_expenses.list");
      }
    }

    async function preLoad() {
      await vm.getOthersEvents();
      await vm.selectVirtualFairs();
      await vm.selectPhysicalFairs();
      activate();
    }

    function getOthersEvents() {
      EventsService.getOthersEvents()
        .then(function(response) {
          return (vm.othersEventsList = response.data);
        })
        .catch(function(err) {
          console.warn(err);
        });
    }

    function selectVirtualFairs() {
      VirtualFairService.getAll()
        .then(function(response) {
          return (vm.virtualFairList = response.data);
        })
        .catch(function(err) {
          console.warn(err);
        });
    }

    function selectPhysicalFairs() {
      return ExpoService.getExpos()
        .then(function(response) {
          return (vm.physicalFairList = response.data);
        })
        .catch(function(err) {
          console.warn(err);
        });
    }

    function uploadAtmFile(atm, event) {
      var file = event.target.files[0];
      var reader = new FileReader();
      reader.onload = function(event) {
        $scope.$apply(function() {
          atm.picture = event.target.result;
          atm.full_file_path = event.target.result;
        });
      };
      reader.readAsDataURL(file);
    }

    vm.preLoad();
  }
})();
